import React from 'react';
export function ProblemSection() {
  return <section className="py-6 px-4 bg-gray-50" data-id="element-250" data-mp="14h4zv2xnw1xw">
      <div className="max-w-3xl mx-auto" data-id="element-251" data-mp="2lstjzhrrqcfl">
        <h2 className="text-[20px] font-black mb-4 text-center text-[#5B3FA0]" data-id="element-252" data-mp="2ltw85hxpi0rt">
          EL PROBLEMA QUE MUCHOS DOCENTES DE SECUNDARIA VIVEN CADA AÑO
        </h2>

        <p className="text-xl mb-3 font-medium text-center md:text-left" data-id="element-253" data-mp="2vq7n6fool4py"></p>

        <ul className="space-y-2 text-lg text-gray-700 mb-5 max-w-2xl mx-auto" data-id="element-254" data-mp="39hma2xlplq2a">
          <li className="flex items-start" data-id="element-255" data-mp="39jqnc65i01f8">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-256" data-mp="35f94c96yps5i">•</span>
            <span data-id="element-257" data-mp="3jftqnfc3663r">
              Llega el momento de trabajar ESI y no sabés por dónde empezar.
            </span>
          </li>
          <li className="flex items-start" data-id="element-258" data-mp="3ei0fs8zu8nx5">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-259" data-mp="3ef5z8sjy3n90">•</span>
            <span data-id="element-260" data-mp="1p2avgc5j2zlm">Encontrás materiales pensados para primaria.</span>
          </li>
          <li className="flex items-start" data-id="element-261" data-mp="1k49a1kkmqo6z">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-262" data-mp="jd3nyp3uidry">•</span>
            <span data-id="element-263" data-mp="jey65vnqfrsc">
              Terminás adaptando recursos que no fueron creados para
              adolescentes.
            </span>
          </li>
          <li className="flex items-start" data-id="element-264" data-mp="sda0a7nt57pj">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-265" data-mp="scidnmc6ukbe">•</span>
            <span data-id="element-266" data-mp="x5bi093qvqmy">
              Improvisás actividades porque no encontrás propuestas claras.
            </span>
          </li>
          <li className="flex items-start" data-id="element-267" data-mp="125pf4w3t5g67">
            <span className="text-[#5B3FA0] mr-3 font-bold text-xl" data-id="element-268" data-mp="1726buep2p2uw">•</span>
            <span data-id="element-269" data-mp="1c1sq8rgn0p5a">Te cuesta abordar temas sensibles con seguridad.</span>
          </li>
        </ul>

        <p className="text-xl text-center mb-3 font-[800] text-[#2E9E8F]" data-id="element-270" data-mp="1g3dy1yebed8m">
          Lo peor es esa sensación de pensar: "Podría trabajar mucho mejor estos
          temas si tuviera todo listo."
        </p>
      </div>
    </section>;
}